import { Component, ChangeDetectionStrategy } from '@angular/core';
import {Router} from "@angular/router";

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorPageComponent {
  constructor(private router: Router) {
  }

  GoToHome(){
    this.router.navigateByUrl('/');
  }
}
